<div role="contentinfo" class="footer text-white text-center">
  <div class="bg-footer text-white font-size-10 d-flex flex-column align-items-center justify-content-center w-100 footer-text">
    <img [src]="'logo/club-bear-logo.svg' | contentAssetImage" alt="Club Bear Logo"  class="mb-3"/>
    {{ 'footer.text.title' | translate }} <br />{{ 'footer.text.description' | translate }}
  </div>
</div>
